'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import CheckBox from '../CheckBox/index.js';
import LoadingIcon from '../Images/LoadingIcon/index.js';
import RemoveIcon from '../Images/RemoveIcon/index.js';
import LimitedTextarea from '../LimitedTextarea/index.js';
import Popup from '../Popup/index.js';
import { showToast, TOAST_TYPE_ERROR } from '../Toast/index.js';
import { ELanguage, colors } from '../Utils/constants.js';
import { eventHelper } from './helper.js';
import { useReportCompany } from './hooks.js';
import { reportCompanyService } from './services.js';
import { ReportCompanyDialog as ReportCompanyDialog$1, Company, Reason } from './styles.css.js';

var LIMIT_TEXT = 500;
var OPEN_REPORT_DIALOG = 'open-report-company-dialog';
var CLOSE_REPORT_DIALOG = 'close-report-company-dialog';
var DEFAULT_COMPANY_LOGO = 'img/company-default-logo.svg';
var otherReasonID = 1;
var openReportDialog = function (locationClassName) {
    return new Promise(function (resolve) {
        eventHelper.emit("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName));
        eventHelper.on("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), function (e) {
            resolve(e.detail);
        });
    });
};
var ReportCompanyDialog = function () {
    var _a, _b;
    var _c = useReportCompany(), data = _c.data, language = _c.language, t = _c.t, locationClassName = _c.locationClassName;
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = useState([]), reasonsSelected = _e[0], setReasonsSelected = _e[1];
    var _f = useState([]), reasons = _f[0], setReasons = _f[1];
    var _g = useState(false), isLoadingFetchReasons = _g[0], setIsLoadingFetchReason = _g[1];
    var _h = useState(false), isLoadingReportCompany = _h[0], setIsLoadingReportCompany = _h[1];
    var _j = useState(''), detailDescription = _j[0], setDetailDescription = _j[1];
    var _k = useState(false), isShowButton = _k[0], setIsShowButton = _k[1];
    var _l = useState(false), isShowError = _l[0], setIsShowError = _l[1];
    var handleClose = function (status) {
        if (status === void 0) { status = false; }
        setIsOpen(false);
        setDetailDescription('');
        setIsShowButton(false);
        setIsShowError(false);
        eventHelper.emit("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), {
            detail: status
        });
    };
    var fetchReasons = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoadingFetchReason(true);
                    if (!(data === null || data === void 0 ? void 0 : data.apiTokenAccess)) return [3 /*break*/, 2];
                    return [4 /*yield*/, reportCompanyService.getReportList("".concat(data.apiGetway, "/company/report-reasons"), data.apiTokenAccess)];
                case 1:
                    response = _a.sent();
                    setReasons((response === null || response === void 0 ? void 0 : response.data) || []);
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.log(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingFetchReason(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var openDialogHandler = function () {
            setIsOpen(true);
        };
        eventHelper.on("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName), openDialogHandler);
        return function () {
            eventHelper.off("".concat(OPEN_REPORT_DIALOG, "-").concat(locationClassName), openDialogHandler);
            eventHelper.off("".concat(CLOSE_REPORT_DIALOG, "-").concat(locationClassName), function () { });
        };
    }, []);
    useEffect(function () {
        if (isOpen && reasons.length === 0) {
            fetchReasons();
        }
    }, [isOpen]);
    var handleReportCompany = function () { return __awaiter(void 0, void 0, void 0, function () {
        var postData, reportCompanyResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (detailDescription.length === 0) {
                        setIsShowError(true);
                        return [2 /*return*/];
                    }
                    if (detailDescription.length > LIMIT_TEXT) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsLoadingReportCompany(true);
                    postData = {
                        reasonIds: reasonsSelected,
                        description: detailDescription,
                        companyId: data === null || data === void 0 ? void 0 : data.company.companyId,
                        userId: data === null || data === void 0 ? void 0 : data.userId
                    };
                    return [4 /*yield*/, reportCompanyService.makeReport(postData, "".concat(data === null || data === void 0 ? void 0 : data.apiGetway, "/company/report"), (data === null || data === void 0 ? void 0 : data.apiTokenAccess) || '')];
                case 2:
                    reportCompanyResponse = _a.sent();
                    if ((reportCompanyResponse === null || reportCompanyResponse === void 0 ? void 0 : reportCompanyResponse.success) === true) {
                        handleClose(true);
                    }
                    else {
                        showToast(t('Report Company error'), t("Can't update this Report Company"), TOAST_TYPE_ERROR);
                        handleClose(false);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a.sent();
                    showToast(t('Report Company error'), t("Can't update this Report Company"), TOAST_TYPE_ERROR);
                    handleClose(false);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingReportCompany(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleReasonChecked = function (checked, item) {
        var myReasonList = reasonsSelected;
        if (checked) {
            myReasonList.push(item.reasonId);
        }
        else {
            myReasonList = myReasonList.filter(function (reason) { return reason !== item.reasonId; });
        }
        if (item.reasonId === otherReasonID) {
            if (isShowError && !checked) {
                setIsShowError(false);
            }
        }
        if (myReasonList.length === 0) {
            setIsShowButton(false);
        }
        else {
            setIsShowButton(true);
        }
        setReasonsSelected(myReasonList);
    };
    var getInputText = function (text) {
        var finalText = text.trim();
        if (finalText.length > 0) {
            setIsShowError(false);
        }
        setDetailDescription(finalText);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Popup, { isShow: isOpen, onClickOutside: handleClose, onClose: handleClose, lang: language === 'vi' ? ELanguage.VI : ELanguage.EN, custom: {
                footer: React__default.createElement(React__default.Fragment, null),
                header: React__default.createElement(React__default.Fragment, null)
            }, styleOption: {
                size: 'sm'
            } },
            React__default.createElement(ReportCompanyDialog$1.Container, null,
                React__default.createElement(ReportCompanyDialog$1.Header, null,
                    React__default.createElement(ReportCompanyDialog$1.Title, null, t('Report company')),
                    React__default.createElement(ReportCompanyDialog$1.Action, { onClick: function () { return handleClose(); } },
                        React__default.createElement(RemoveIcon, null))),
                React__default.createElement(ReportCompanyDialog$1.Body, null,
                    React__default.createElement(Company.Container, null,
                        React__default.createElement(Company.Image, { src: ((_a = data === null || data === void 0 ? void 0 : data.company) === null || _a === void 0 ? void 0 : _a.companyLogo) || "".concat(data === null || data === void 0 ? void 0 : data.imagesService, "/").concat(DEFAULT_COMPANY_LOGO) }),
                        React__default.createElement(Company.Wrapper, null,
                            React__default.createElement(Company.Name, null, (_b = data === null || data === void 0 ? void 0 : data.company) === null || _b === void 0 ? void 0 : _b.companyName))),
                    isLoadingFetchReasons && (React__default.createElement(Reason.SkeletonContainer, null, new Array(9).fill(1).map(function (_, index) {
                        return React__default.createElement(Reason.Skeleton, { height: 28, key: index });
                    }))),
                    !isLoadingFetchReasons && reasons.length > 0 && (React__default.createElement(Reason.Container, null, reasons.map(function (item, index) { return (React__default.createElement(CheckBox, { label: language === 'vi' ? item.reasonVi : item.reasonEn, onCheckChange: function (checked) { return handleReasonChecked(checked === 'checked', item); }, key: "report-company-checkbox-".concat(index) })); }))),
                    React__default.createElement(LimitedTextarea, { rows: 4, limit: LIMIT_TEXT, value: detailDescription, language: language, inputText: getInputText, placeholder: t('Details of the reason.') }),
                    isShowError && (React__default.createElement(ReportCompanyDialog$1.TextError, { className: 'text-danger', style: {
                            marginTop: 8
                        } }, t('Please input detail description.')))),
                React__default.createElement(ReportCompanyDialog$1.Footer, null,
                    React__default.createElement(ReportCompanyDialog$1.Button, { onClick: handleReportCompany, type: "primary", disabled: !isShowButton },
                        isLoadingReportCompany && React__default.createElement(LoadingIcon, { bgColor: colors.bgNormal }),
                        React__default.createElement("span", { style: {
                                marginLeft: isLoadingReportCompany ? 8 : 0
                            } }, t('Send'))))))));
};

export { ReportCompanyDialog as default, openReportDialog };
//# sourceMappingURL=ReportCompanyDialog.js.map
